export enum ValidateOtpKeys {
  otp = 'otp',
  email = 'email',
}

export interface ValidateOtp {
  [ValidateOtpKeys.otp]: string;
  [ValidateOtpKeys.email]: string;
}
